try {
    window.$ = window.jQuery = require('jquery');
    window.SimpleMDE = require('simplemde');

    window.axios = require('axios');
    window.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    };

    require('bootstrap5');
} catch (e) {
}

require('./front/index');

